/* eslint-disable react/no-array-index-key */
import React, { FC as ReactFC } from 'react';

import * as download from 'downloadjs';
import * as intl from 'react-intl-universal';
import { Button, Col, Row } from 'reactstrap';

import { formatDate, getCurrentDateTime } from 'helpers/DateFormat';
import DateFormatType from 'shared/enums/DateFormatType';

import styles from './recoveryCodeContainer.module.scss';
import RecoveryCodeContainerProps from './RecoveryCodeContainerProps';

const RecoveryCodeContainer: ReactFC<RecoveryCodeContainerProps> = (
  props: RecoveryCodeContainerProps
) => {
  const { recoveryCodes } = props;

  const copyButtonDefaultText = intl.get('BTN_MFA_RECOVERY_COPY_DEFAULT');
  const copyButtonSuccessText = intl.get('BTN_MFA_RECOVERY_COPY_SUCCESS');
  const copyButtonFailedText = intl.get('BTN_MFA_RECOVERY_COPY_FAILED');
  const [copyButtonText, setCopyButtonText] = React.useState<string>(
    copyButtonDefaultText
  );

  const handleCopy = async (): Promise<void> => {
    if (!recoveryCodes || recoveryCodes.length === 0) return;
    const codesString = recoveryCodes.join('\n');
    try {
      await navigator.clipboard.writeText(codesString);
      setCopyButtonText(copyButtonSuccessText);
      setTimeout(() => {
        setCopyButtonText(copyButtonDefaultText);
      }, 2000);
    } catch (err) {
      setCopyButtonText(copyButtonFailedText);
      setTimeout(() => {
        setCopyButtonText(copyButtonDefaultText);
      }, 2000);
    }
  };

  const handleDownload = async (): Promise<void> => {
    if (!recoveryCodes || recoveryCodes.length === 0) return;
    const codesString = recoveryCodes.join('\n');
    const currentDate = formatDate(
      getCurrentDateTime(),
      DateFormatType.MfaRecoveryCodes
    );
    const filename = `dsi-recovery-codes-${currentDate}.txt`;
    const mimeType = 'text/plain';
    await download(codesString, filename, mimeType);
  };

  return (
    <div className={styles.codesContainer}>
      <Row className={`gy-3 gx-3 ${styles.codesGrid}`}>
        {recoveryCodes.map((code, index) => (
          <Col
            key={index}
            xs="4"
            className={`d-flex justify-content-center ${
              index === 9 ? 'offset-4' : ''
            }`}
          >
            <div className={`text-14-semibold ${styles.recoveryCodeItem}`}>
              {code}
            </div>
          </Col>
        ))}
      </Row>

      <Row className={styles.actionButtonsRow}>
        <Col className="d-flex justify-content-center align-items-center">
          <Button
            outline
            color="secondary"
            size="sm"
            onClick={handleDownload}
            className={`d-inline-flex align-items-center text-12-medium ${styles.actionButton} mr-3`}
          >
            {intl.get('BTN_MFA_RECOVERY_DOWNLOAD')}
            <i className="icon-download ml-2" />
          </Button>
          <Button
            outline
            color="secondary"
            size="sm"
            onClick={handleCopy}
            className={`d-inline-flex align-items-center text-12-medium ${styles.actionButton}`}
          >
            {copyButtonText}
            <i className="icon-copy ml-2" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RecoveryCodeContainer;
